export default __webpack_public_path__ + "static/media/stig.a7756ff9.png";